import React, { useState } from "react";
import Header from "../../../../Components/Header/Header";
import SideBar from "../../../../Components/SideBar/SideBar";
import "./addLocation.scss";
import { useDispatch, useSelector } from "react-redux";
import { insertLocation } from "../../../../api/LocationApi/Location";
import { useAlert } from "react-alert";
import Select from "react-select";
import { getallLang } from "../../../../api/LanguageApi/Lang";
import { Countries } from "../../../../api/CountryApi";
import { useEffect } from "react";
const AddLocation = () => {
  const dispatch = useDispatch();
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [website, setWebsite] = useState("");
  const [email, setEmail] = useState("");
  const [fax, setFax] = useState("");
  const [latitude, setLatitude] = useState("");
  const [langitude, setLangitude] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const alert = useAlert();
  const [productLocation, setProductLocation] = useState("");
  const langs = useSelector((state) => state?.Lang?.lang?.langs);
  const options = langs?.map((language) => ({
    value: language.id,
    label: language.name,
  }));
  const optionsCoun = Countries?.map((item) => ({
    value: item.code,
    label: item.name,
  }));
  useEffect(() => {
    dispatch(getallLang());
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      address: address,
      phone: phone,
      website_url: website,
      email: email,
      fax: fax,
      lat: latitude,
      lang: langitude,
      language_id: selectedOption?.value,
      location: productLocation?.value,
    };
    dispatch(insertLocation(data))
      .unwrap()
      .then((originalPromiseResult) => {
        // handle result here
        alert.show("Sucessful Added");
        console.log(originalPromiseResult);
      })
      .catch((rejectedValueOrSerializedError) => {
        // handle error here
        alert.show(rejectedValueOrSerializedError?.response?.data?.message);

        // alert(rejectedValueOrSerializedError.response.data.message);
        console.log(rejectedValueOrSerializedError);
      });
    // console.log(data);
  };
  return (
    <div className="locationContainer">
      <SideBar />
      <div className="locationWrapper">
        <Header title={"Location"} />
        <form onSubmit={handleSubmit} className="locationBody">
          <div style={{ width: "22vw" }}>
            <p>Language</p>
            <Select
              defaultValue={selectedOption}
              onChange={setSelectedOption}
              options={options}
            />
          </div>
          <div style={{ width: "22vw" }}>
            <p>Country</p>
            <Select
              defaultValue={productLocation}
              onChange={setProductLocation}
              options={optionsCoun}
            />
          </div>
          <div className="locationInput">
            <span>Address</span>
            <input
              type="text"
              placeholder="Address"
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          <div className="locationInput">
            <span>Phone</span>
            <input
              type="text"
              placeholder="Phone"
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div className="locationInput">
            <span>Website_URL</span>
            <input
              type="text"
              placeholder="https://www.youtube.com/"
              onChange={(e) => setWebsite(e.target.value)}
            />
          </div>
          <div className="locationInput">
            <span>Email</span>
            <input
              type="text"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="locationInputContainer">
            <div className="inputSmall">
              <span>Fax</span>
              <input
                type="text"
                placeholder="Fax"
                onChange={(e) => setFax(e.target.value)}
              />
            </div>
            <div className="inputSmall">
              <span>Latitute</span>
              <input
                type="text"
                placeholder="Latitute"
                onChange={(e) => setLatitude(e.target.value)}
              />
            </div>
            <div className="inputSmall">
              <span>Langitute</span>
              <input
                type="text"
                placeholder="Langitute"
                onChange={(e) => setLangitude(e.target.value)}
              />
            </div>
          </div>
          <button>Save</button>
        </form>
      </div>
    </div>
  );
};

export default AddLocation;
